export const GET_LIMITED_NOTIFICATIONS = "GET_LIMITED_NOTIFICATIONS";
export const RESET_LIMITED_NOTIFICATIONS = "RESET_LIMITED_NOTIFICATIONS";
export const START_LOADING_LIMITED_NOTIFICATIONS = "START_LOADING_LIMITED_NOTIFICATIONS";
export const STOP_LOADING_LIMITED_NOTIFICATIONS = "STOP_LOADING_LIMITED_NOTIFICATIONS";
export const ERROR_LOADING_LIMITED_NOTIFICATIONS = "ERROR_LOADING_LIMITED_NOTIFICATIONS";
